// TEAMS Website - SectionHeader Component
// Reusable section header with title, subtitle, and optional actions

import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/main.scss';

const SectionHeader = ({
  title,
  subtitle,
  description,
  alignment = 'center', // left, center, right
  size = 'large', // small, medium, large
  variant = 'default', // default, accent, dark
  actions = [], // Array of action buttons/links
  className = '',
  ...props
}) => {
  const { t } = useTranslation();

  // Base classes
  const baseClasses = 'section-header';
  
  // Alignment classes
  const alignmentClasses = {
    left: 'section-header--left',
    center: 'section-header--center',
    right: 'section-header--right'
  };

  // Size classes
  const sizeClasses = {
    small: 'section-header--small',
    medium: 'section-header--medium',
    large: 'section-header--large'
  };

  // Variant classes
  const variantClasses = {
    default: 'section-header--default',
    accent: 'section-header--accent',
    dark: 'section-header--dark'
  };

  // Combine classes
  const headerClasses = [
    baseClasses,
    alignmentClasses[alignment] || alignmentClasses.center,
    sizeClasses[size] || sizeClasses.large,
    variantClasses[variant] || variantClasses.default,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={headerClasses} {...props}>
      <div className="section-header__container">
        {/* Title */}
        {title && (
          <h2 className="section-header__title">
            {title}
          </h2>
        )}

        {/* Subtitle */}
        {subtitle && (
          <p className="section-header__subtitle">
            {subtitle}
          </p>
        )}

        {/* Description */}
        {description && (
          <p className="section-header__description">
            {description}
          </p>
        )}

        {/* Actions */}
        {actions.length > 0 && (
          <div className="section-header__actions">
            {actions.map((action, index) => (
              <div key={index} className="section-header__action">
                {action}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
